<template>
  <div class="developmentPlanning">
    <Menu></Menu>
    <div id="developmentPlanning">
		<div class="developmentPlanning-first-screen">
			<img src="../assets/img/guihua.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/guihuaMb.jpg" alt="" class="mbStyle"/>
			<div class="developmentPlanning-first-text">
				<div>发展规划</div>
				<div>努力建设无废城市，为建设美丽中国、美丽黑龙江做出贡献</div>
			</div>
		</div>
		<div class="developmentPlanning-second-screen">
			<img src="../assets/img/guihuaSencond.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/guihuaSencondmb.jpg" alt="" class="mbStyle"/>
			<div class="developmentPlanning-second-screen-flex">
				<div>
					Construction of renewable resources base
				</div>
				<div>
					建设再生资源回收体系<br/>终端处理基地
				</div>
				<div>
					以哈尔滨再生资源回收体系与产业园区为核心相衔接的模式复制向全省其他地、市、县（市）推广，<span>在齐齐哈尔、大庆、佳木斯、黑河、牡丹江等64个城市</span>建设再生资源回收体系、终端处理基地。
				</div>
			</div>
		</div>
		<div class="developmentPlanning-second-screen">
			<img src="../assets/img/ziyuan.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/ziyuanMb.jpg" alt="" class="mbStyle"/>
			<div class="developmentPlanning-second-screen-flex developmentPlanning-second-screen-city">
				<div>
					Industrial unification
				</div>
				<div>
					形成全省再生资源<br/>产业统一
				</div>
				<div>
					实现再生资源行业规模化、规范化、产业化发展的良好格局
				</div>
			</div>
		</div>
		<div class="developmentPlanning-second-screen">
			<img src="../assets/img/chengshi.jpg" alt="" class="pcStyle"/>
			<img src="../assets/img/chengshiMb.jpg" alt="" class="mbStyle"/>
			<div class="developmentPlanning-flex">
				<div class="developmentPlanning-flex-left">
					<div class="pcStyle">
						无废城市
					</div>
					<div>
						No waste city
					</div>
					<div>建设美丽中国<br/>美丽黑龙江</div>
				</div>
				<div class="developmentPlanning-flex-right">
					<div>
						中亚环保科技集团将继续致力以创新、协调、绿色、开放、共享的新发展理念为引领，通过推动形成绿色发展方式和生活方式，持续推进固体废物源头减量和资源化利用，将固体废物环境影响降至最低，努力建设无废城市，为建设美丽中国、美丽黑龙江做出贡献。
					</div>
				</div>
			</div>
		</div>
	</div>
	<Footer></Footer>
  </div>
</template>
<script>
  import axios from "axios";
  import Menu from './menu';
  import Footer from './footer';
  import Swiper,{Navigation, Pagination,Autoplay,Mousewheel} from 'swiper'
  Swiper.use([Navigation, Pagination,Autoplay,Mousewheel])
  export default {
    name: 'developmentPlanning',
    components:{
     Menu,
	 Footer
    },
     data () {
      return {
		
      };
    },
	mounted(){
		
	},
	methods: {
		
	},
  }
</script>
<style scoped>
@import '../assets/scss/commen.scss';
@import '../assets/scss/developmentPlanning.scss';

</style>


// WEBPACK FOOTER //
// src/components/developmentPlanning.vue